import name from 'forms/shared/validators/models/name/name';
import locationUSCityStateZipInternationalCityModelValidator from 'forms/shared/validators/models/location/models/usCityStateZipInternationalCity';
import { hasYesOrNo } from 'models/validate';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { setToStartOfMonth } from 'helpers/date';
import { isSafeUnitedStates } from 'helpers/locations';
import { ForeignBusinessEmploymentItemModel } from '../types';

export const foreignBusinessEmploymentItemValidator: ValidateJSModel<ForeignBusinessEmploymentItemModel> = {
  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, model: { validator: pvqNameModelValidator } };
    }

    return { presence: true, model: { validator: name } };
  },

  Description: { hasValue: true },

  Date: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { earliest: options?.applicantBirthdate, latest: DEFAULT_LATEST },
  }),
  Address: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        location: {
          validator: pvqLocationModelValidator,
          requireStreet: isSafeUnitedStates(value)
        }
      };
    }

    return { presence: true, location: { validator: locationUSCityStateZipInternationalCityModelValidator } };
  },

  Accepted: { hasValue: { validator: hasYesOrNo } },

  AcceptedDate: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      const validationCondition = (attributes?.Accepted?.value === 'Yes');
      if (validationCondition) {
        return {
          presence: true,
          date: {
            earliest: attributes?.Date,
            tooEarly: 'error.date.acceptedDateTooEarly',
            latest: DEFAULT_LATEST
          },
        };
      }
    }
    return {};
  },

  Explanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.Accepted?.value !== 'No') {
      return {};
    }

    return { hasValue: true };
  },

  PerformedService: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.Accepted?.value === 'Yes') {
      return { hasValue: { validator: hasYesOrNo } };
    }

    return {};
  },

  DatesPerformed: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.PerformedService?.value === 'Yes') {
      return {
        presence: true,
        daterange: {
          earliest: attributes?.AcceptedDate,
          tooEarly: 'error.date.performedDateTooEarly',
          latest: DEFAULT_LATEST
        },
      };
    }

    return {};
  },

  Compensation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.PerformedService?.value === 'Yes') {
      return { hasValue: true };
    }

    return {};
  },

  HasOngoingObligations: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.PerformedService?.value === 'Yes') {
      return { hasValue: { validator: hasYesOrNo } };
    }

    return {};
  },

  OngoingObligationsExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.PerformedService?.value === 'Yes') {
      return { hasValue: true };
    }

    return {};
  },

};
